import { href } from '../router';
import { EmptyState } from '../ui/primitives';
import { Screen } from '../ui/layout';

export function NotFound() {
  return (
    <Screen max={560} label="Page not found">
      <EmptyState
        icon="map"
        title="This page is off the map"
        action={
          <a className="btn btn--primary" href={href()}>
            Back to the start
          </a>
        }
      >
        The link may be old or mistyped.
      </EmptyState>
    </Screen>
  );
}
